import { Component, input, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TextareaModule } from 'primeng/textarea';
import { ImageSources } from '../../../constants/image-sources';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'blindspot-user-deactivated-popup',
  styleUrls: ['./user-deactivated.popup.scss'],
  imports: [
    TextareaModule,
    FormsModule,
    ButtonModule,
    DialogModule,
    TranslocoModule,
  ],
  template: `
    <div class="complete-profile-wrapper" *transloco="let t">
      <p-dialog [(visible)]="visible" [modal]="true" [closable]="false">
        <ng-template #header>
          <h3 class="popup-header">
            <img class="logo" alt="Logo" [src]="ImageSources.logo" />
          </h3>
        </ng-template>
        <div class="content">
          <div class="text">
            <h3>{{ t('status.accountDeactivated') }}</h3>
            <p>
              {{ t('status.accountDeactivatedMessage') }}
            </p>
          </div>
          <p-button
            label="Logout"
            variant="outlined"
            [style]="{ width: '100%' }"
            icon="pi pi-sign-out"
            (onClick)="logout.emit(true)"
          />
        </div>
      </p-dialog>
    </div>
  `,
})
export class UserDeactivatedPopup {
  public visible = model<boolean>(false);
  public logout = output<boolean>();

  protected readonly ImageSources = ImageSources;
}
